import { render, staticRenderFns } from "./tree-table.vue?vue&type=template&id=9c4d22b2&scoped=true&"
import script from "./tree-table.vue?vue&type=script&lang=js&"
export * from "./tree-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4d22b2",
  null
  
)

export default component.exports